<template>
  <div id="app">
    <kendo-notification
      ref="popupNotification"
      :position-top="300"
      stacking="down"
    ></kendo-notification>
    <component :is="addLayout">
      <router-view />
    </component>
  </div>
</template>

<script>
const defaultLayout = "defaultlayout";
import kendo from "@progress/kendo-ui";

export default {
  name: "App",
  computed: {
    addLayout() {
      return this.$route.meta.layout || defaultLayout;
    },
  },
  watch: {
    $route(to) {
      document.title = to.meta.title || "VTS";
    },
  },
  methods: {
    showPopupNotification: function (payload) {
      this.popupNotificationWidget.show(
        payload.message,
        payload.type || "info"
      );
    },
  },
  async created() {
    this.unsubscribe = this.$store.subscribe((mutation) => {
      if (mutation.type == "setSeclectedFacility") {
        this.$store.dispatch("loadInitialData", null, { root: true });
      }
    });
  },
  beforeDestroy() {
    this.unsubscribe();
  },
  async mounted() {
    // console.log(this.$refs);
    this.popupNotificationWidget = this.$refs.popupNotification.kendoWidget();
    this.$store.subscribe((mutation) => {
      if (mutation.type == "notify") {
        this.showPopupNotification(mutation.payload);
      }
    });
  },
  data() {
    return {
      kendo,
    };
  },
};
</script>

<style>
@import "~leaflet.markercluster/dist/MarkerCluster.css";
@import "~leaflet.markercluster/dist/MarkerCluster.Default.css";
@import '~vue-swatches/dist/vue-swatches.css'
</style>
